export const REDEMPTION_STATES = {
  PRE_PII: 'pre-pii',
  POST_PII_REDEMPTION_PENDING: 'post-pii-redemption-pending',
  POST_PII_REDEMPTION_FINALIZED: 'post-pii-redemption-finalized',
};
